<template>
  <header class="plan-header">
    <div class="plan-cover-container">
      <product-cover :src="plan.cover"
                     :alt="plan.title"
                     :target-id="plan.id"
                     target-type="schedule"
                     :show-get-point="false"
      />
      <slot></slot>
    </div>
    <p class="plan-title-desc">该学习计划包括以下{{ plan.products.length | numberToCh }}门音频课程：</p>
    <h3 class="product-title"
        v-for="(item, index) in plan.products"
        :key="index"
    >
      {{ item.title }}
    </h3>
    <p class="plan-summary">{{ plan.summary }}</p>
    <div class="header-bottom">
      <price :price="price"
      />
    </div>
  </header>
</template>

<script>
  import Price from '@/components/Price/ProductDetailPrimaryPrice';
  import ProductCover from '@/components/ProductDetailHeaderCover';

  export default {
    name: 'PlanDetailHeader',
    components: {
      Price,
      ProductCover,
    },
    props: {
      plan: {
        type: Object,
        required: true,
      },
      price: {
        type: Object,
        required: true,
      },
    },
  };
</script>

<style scoped lang="less">
  @import '~@/assets/styles/var.less';

  .plan-header {
    background: @color-white;
    margin-bottom: @size-small;
    padding: 0 @size-base @size-base;
  }

  .plan-cover-container {
    margin: 0 -@size-base;
    position: relative;
  }

  .plan-cover {
    width: 100%;
    background-color: @background-color-base;
    img {
      display: block;
      width: 100%;
      height: 100%;
    }
  }

  .plan-title-desc {
    color: @color-text-light;
    margin-top: @size-small;
    margin-bottom: @size-extra-small;
  }

  .plan-summary {
    margin: @size-small 0 @size-base;
    font-size: @font-size-small;
    color: @color-text-light;
  }

  .plan-desc {
    display: flex;
    align-items: center;
    color: @color-text-lighter;
    font-size: @font-size-small;
  }

  .product-title {
    margin: 0 0 @size-extra-small;
    font-size: @font-size-medium;
    font-weight: @font-weight-primary;
    color: @color-text-base;
  }

  .label-team-size {
    margin-bottom: @size-extra-small;
    font-size: @font-size-extra-small;
    color: @group-buy-team-size-color;
    background: @group-buy-team-size-background;
    border-radius: @border-radius-medium;
  }

  .plan-play-count {
    display: inline-flex;
    align-items: center;
    line-height: 1;
    .icon {
      margin-right: @size-extra-small / 2;
    }
  }

</style>
